import { render, staticRenderFns } from "./authBar.vue?vue&type=template&id=47cc0020&scoped=true&"
import script from "./authBar.vue?vue&type=script&lang=js&"
export * from "./authBar.vue?vue&type=script&lang=js&"
import style0 from "./authBar.vue?vue&type=style&index=0&id=47cc0020&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47cc0020",
  null
  
)

export default component.exports